import * as Yup from "yup";

const PhoneDetailSchema = Yup.object().shape({
  phone_number: Yup.string()
    .required("Phone number is required")
    .test("is-valid-phone", "Please enter a valid phone number", (value) => {
      return value && value.replace(/\D/g, "").length >= 7;
    }),
});

const OtpVerificationSchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP must be 6 digits")
    .required("OTP is required"),
});

export { PhoneDetailSchema, OtpVerificationSchema };
